import { render } from "./CustomLoader.vue?vue&type=template&id=8b9f0b96&scoped=true"
import script from "./CustomLoader.vue?vue&type=script&lang=js"
export * from "./CustomLoader.vue?vue&type=script&lang=js"

import "./CustomLoader.vue?vue&type=style&index=0&id=8b9f0b96&scoped=true&lang=css"

import exportComponent from "/var/www/www.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b9f0b96"]])

export default __exports__